import {useCallback, useContext} from 'react';

import PopupContext from '@/src/popup/utils/PopupContext';
import AcademicTitleWidgetLayout from '@/src/profile/accountSettings/components/AcademicTitleWidgetLayout';
import EditAcademicTitlePopup from '@/src/profile/accountSettings/containers/EditAcademicTitlePopup';

interface AcademicTitleWidgetProps {
  prefixedAcademicTitle?: string | null;
  suffixedAcademicTitle?: string | null;
}

const AcademicTitleWidget = ({
  prefixedAcademicTitle,
  suffixedAcademicTitle,
}: AcademicTitleWidgetProps) => {
  const {openPopup} = useContext(PopupContext);

  const handleEditClick = useCallback(async () => {
    // @ts-ignore
    openPopup({
      popup: (
        <EditAcademicTitlePopup
          prefixedAcademicTitle={prefixedAcademicTitle}
          suffixedAcademicTitle={suffixedAcademicTitle}
        />
      ),
      options: {withCloseButton: true},
    });
  }, [prefixedAcademicTitle, suffixedAcademicTitle]);

  return (
    <AcademicTitleWidgetLayout
      prefixedAcademicTitle={prefixedAcademicTitle}
      suffixedAcademicTitle={suffixedAcademicTitle}
      onEditClick={handleEditClick}
    />
  );
};

export default AcademicTitleWidget;
